import { useState } from "react";
import {  useUpdateProfilMutation, useUpdateProfilePhotoMutation } from "context/users/usersApiSlice";

// Material Dashboard 2 React components
import MDBox from "dashboard/components/MDBox";
import MDTypography from "dashboard/components/MDTypography";
import MDButton from "dashboard/components/MDButton";

import MDAvatar from "dashboard/components/MDAvatar";
import Divider from "@mui/material/Divider";
import { Grid, Icon, Tooltip } from "@mui/material";

import useAlert from "hooks/useAlert";
import ImageCropper from "dashboard/examples/Forms/easyCrop";
import CheckoutForm from "components/Author/Forms"


const UserInfos = ({profile}) => {

  const {showAlerts} = useAlert();
  const [updateProfile, {isLoading}] = useUpdateProfilMutation();
  const [UpdatePhoto, {isLoading : loadingUp , error : errorUpload }] = useUpdateProfilePhotoMutation();
  const [profilePhoto, setProfilePhoto] = useState(profile?.selectedImage);

  /*eslint-disable*/
  const UpdateFunction = async update => {
      try{
          const userData = await updateProfile({id : profile?.id, update}).unwrap();
          showAlerts({code:"success", msg : userData.message, title: "Profile update " ,type : "toast"});
          if(update.hasOwnProperty('selectedImage')) setProfilePhoto(update.selectedImage); 
        } catch(err) {
              let errMsgs = "ERROR : ";
              if(err.status === 401 || err.originalStatus === 401 ){
                  errMsgs += `unauthorized access !!, ${err.error || null }`;
              }else if(err.originalStatus === 204 || err.originalStatus === 400){
                  errMsgs += "unable to UPDATE user profile !";
              }else if(err.status === 429 ){
                  errMsgs += err.error;
              }else{
                  errMsgs += err.data?.error;
              }
              showAlerts({code:"error", msg : errMsgs, title: "Profile update error" ,type : "toast"});
        }
  }
  
  const selectThisImg = (item,path) =>{
      if(item === profile.selectedImage.split('/').pop()) {
          return showAlerts({code:"info",icon:"info", title : "Change Profile photo", msg : "Your are using this picture !", type : "toast"});
      }
      UpdateFunction({selectedImage:path})
  }

  const onDelete = async item =>{
      if(item === profile.selectedImage.split('/').pop()) {
          return showAlerts({code:"info", icon:"info", title : "Delete Profile photo", msg : "Your are using this picture !", type : "toast"});
      }
      const data ={
      name : item,
      user_id : profile.id
      };
      showAlerts({code:"warning", icon:"warning", title : "Delete Profile photo", msg : "Are you sure you want to delete this image ?  ", type : "confirm", action: data});
  }

  const handleUpload = async formData =>{
      formData.append("user_id",profile?.id);
      const uploadResponse = await UpdatePhoto(formData);
      return uploadResponse;
  }
  
  return (
    
    <Grid container spacing={{ xs: 1, md: 2 }} >    
        <Grid xs={12} px={1} md={4} sx={{textAlign:"center"}} item>
            <ImageCropper handleUpload={handleUpload} isLoading={loadingUp} errorUpload={errorUpload}  profilImage={`${process.env.REACT_APP_PUBLIC_URL}/img/profil/${profilePhoto}`} />
            <MDTypography variant="caption">Profile photos : <span style={{color : 'initial'}}>{profile?.photos?.length}</span></MDTypography>
            <MDBox p={.5} sx={{maxHeight:"400px", overflowY:"scroll"}}>
                  {profile?.photos?.map(image =>(
                    <Grid key={image.name} justifyItems="center" justifyContent="center"  sx={{ border:'.1em dashed #eaeaea', p:.5, borderRadius:1.6, my:.5 }} container>
                      <Grid xs={2} item>
                        <MDAvatar src={`${process.env.REACT_APP_PUBLIC_URL}/img/profil/${image.path}`} alt={image.name} />
                      </Grid>
                      <Grid xs={8} sx={{alignSelf:"center"}}  textAlign="left" item>
                        <Tooltip title="Click to select this image as a profile picture" placement="top">
                          <MDButton variant="text" sx={{px:1}} onClick={()=>selectThisImg(image.name,image.path)}>
                            <MDTypography noWrap  variant="caption">{image.name}</MDTypography>
                          </MDButton>
                        </Tooltip>
                      </Grid>
                      <Grid xs={2} sx={{alignSelf:"center"}} item>
                        <MDButton variant="outlined" color="secondary"  sx={{minHeight:35, minWidth:35, p:.5}}  onClick={()=>onDelete(image.name)}><Icon size="medium">close</Icon></MDButton>
                      </Grid>
                    </Grid>).reverse()
                  )}
            </MDBox>
        </Grid>
        <Grid xs={12} md={8} sx={{ display: "flex" }}  item>
            <Divider orientation="vertical" sx={{ ml: -2, mr: 1 }} />
            <CheckoutForm action={UpdateFunction} isLoading={isLoading}/>
        </Grid>
    </Grid>      
  )
}

export default UserInfos